import type { AuthProviderProps } from "./auth.type";

import { useState } from "react";

import { client } from "@/config/client";

import { AuthContext } from "./auth.context";
import { isValidToken } from "./auth.helper";

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [token, setTokenState] = useState<string | null>(null);
  const hasToken = isValidToken(token ?? undefined);

  const setToken = (token?: string) => {
    const tokenValue = token ?? null;
    setTokenState(tokenValue);
    client.auth.setToken(tokenValue ?? undefined);
  };

  return (
    <AuthContext.Provider value={{ token, hasToken, setToken }}>
      {children}
    </AuthContext.Provider>
  );
};
